import React, { useState, useEffect } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import GreyArrow from "../assets/greyLeftAr.png";
import FilterIcon from "../assets/filterIcon.png";
import Search from "../assets/search.png";
import Email from "../assets/mailRed.png";
import GuestIcon from "../assets/guestIcon.png";
import { Modal } from "react-bootstrap";
import MsgBox from "../assets/orngMsg.svg";
import OrngMsg from "../assets/orngMsg.svg";
import userIcn from "../assets/person_pin_circle.svg";
import { FaRegEye, FaTimes } from "react-icons/fa";
import DatePicker from "react-datepicker";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import {
  options_search,
  GuestManagementPageText,
} from "./../CommonJquery/WebsiteText";
import {
  server_post_data,
  get_all_contact_data,
  update_guest_vip_status,
  get_all_notes_by_id,
  APL_LINK,
} from "../ServiceConnection/serviceconnection.js";
import {
  handleError,
  computeTodayDate,
  handleIaphabetnumberChange,
  handleAphabetsChange,
  handleEmailChange,
  handleNumbersChange,
  computeplussevendays,
  mondayDayYearFormat,
  goBack,
  formatToYYYYMMDD,
} from "../CommonJquery/CommonJquery";
import { Button } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import { Eye } from "lucide-react";
import { filter } from "jszip";

function GuestMngmt() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [editStaffData, seteditStaffData] = useState([]);
  // Set initial state using useState hook
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [SelectedData, setSelectedData] = useState([]);
  const [searchfilter, setSearchFilter] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [flagData, setflagData] = useState("1");
  const [selectedValue, setSelectedValue] = useState("Name"); // State to hold the selected value
  const [noteShow2, setNoteShow2] = useState(false);
  const [SelectedDataDetails, setSelectedDataDetails] = useState([]);
  const [StaffImageLinkData, setsStaffImageLinkData] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [imgname, setimgname] = useState("");
  const [ownCarTab, setOwnCarTab] = useState(true);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Set to 10 items per page as requested

  const handleSelect = (event) => {
    setSelectedValue(event.target.value);
  };

  const exportToCSV = (csvData, fileName, fileExtension) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  useEffect(() => {
    const flag = "1";
    let call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  }, []);

  useEffect(() => {
    // Reset to first page when data changes
    setCurrentPage(1);
  }, [filteredData]);

  const search_data = () => {
    const flag = "2";
    const call_id = "0";
    master_data_get(startDate, endDate, flag, call_id);
  };

  const master_data_get = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("from_where", 0);
    fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("end_date", formatToYYYYMMDD(end_date));
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue);
    fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_all_contact_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setimgname(APL_LINK + Response.data.message.image_link);
          seteditStaffData(Response.data.message.data_subscribe);
          let data = Response.data.message.data_subscribe;
          let filtered = data.filter(
            (item) => item.source?.toLowerCase() !== "resources"
          );
          setfilteredData(filtered);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const master_data_get_new = async (start_date, end_date, flag, call_id) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    setflagData(flag);
    fd.append("from_where", 0);
    fd.append("start_date", formatToYYYYMMDD(start_date));
    fd.append("end_date", formatToYYYYMMDD(end_date));
    fd.append("flag", flag);
    fd.append("call_id", call_id);
    fd.append("search_option", selectedValue);
    fd.append("search_data", document.getElementById("search_data").value);
    await server_post_data(get_all_contact_data, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setimgname(APL_LINK + Response.data.message.image_link);
          seteditStaffData(Response.data.message.data_subscribe);
          let data = Response.data.message.data_subscribe;
          let filtered = data.filter(
            (item) => item.source?.toLowerCase() === "resources"
          );
          setfilteredData(filtered);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  const handleSearch = (event) => {
    const searchValue = event.target.value;
    setSearchFilter(searchValue);

    // Filter table data based on search value
    const filteredDatashow = editStaffData.filter((row) => {
      return Object.values(row).some((value) => {
        if (value !== null && value !== undefined) {
          // Add null check here
          return (
            typeof value === "string"
              ? value.toLowerCase()
              : value.toString().toLowerCase()
          ).includes(searchValue.toLowerCase());
        }
        return false;
      });
    });

    setfilteredData(filteredDatashow);
  };

  const handleShowModal = (message) => {
    setModalMessage(message);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleViewClick = (event, drivingimg) => {
    event.stopPropagation(); // Prevent triggering file upload click
    if (drivingimg) {
      const newTab = window.open();
      newTab.document.write(
        `<img src="${drivingimg}" style="max-width:50%; height:auto;" />`
      );
      newTab.document.title = "Uploaded Image";
    } else {
      const newTab = window.open();
      newTab.document.write(
        `<img src="${drivingimg}" style="max-width:50%; height:auto;" />`
      );
      newTab.document.title = "Uploaded Image";
    }
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  // default: Owned cars

  const toggleTabs = (tab) => {
    setOwnCarTab(tab === "own");
    const flag = "1";
    let call_id = "0";
    const isOwn = tab === "own";
    setOwnCarTab(isOwn);
    if (isOwn) {
      master_data_get(startDate, endDate, flag, call_id);
    } else {
      master_data_get_new(startDate, endDate, flag, call_id);
    }
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPaginationButtons = () => {
    const buttons = [];

    // Previous button
    buttons.push(
      <li className="cust_hist_page_item" key="prev">
        <button
          className="cust_hist_page_link cust_hist_page_prev"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <span className="sr-only">Previous</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    // Page buttons
    // Show max 5 page buttons with current page in the middle when possible
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, startPage + 4);

    // Adjust startPage if endPage is at maximum
    if (endPage === totalPages) {
      startPage = Math.max(1, endPage - 4);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <li className="cust_hist_page_item" key={i}>
          <button
            className={`cust_hist_page_link ${
              currentPage === i ? "cust_hist_page_active" : ""
            }`}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </button>
        </li>
      );
    }

    // Next button
    buttons.push(
      <li className="cust_hist_page_item" key="next">
        <button
          className="cust_hist_page_link cust_hist_page_next"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
        >
          <span className="sr-only">Next</span>
          <svg
            className="cust_hist_page_icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </li>
    );

    return buttons;
  };

  const downloadCSV = () => {
    const headers = ["Date", "Name", "Email", "Phone", "Message"];

    const rows = editStaffData.map((enquiry) => [
      enquiry.entry_date || "",
      enquiry.name || "",
      enquiry.email || "",
      enquiry.phone || "",
      enquiry.message?.replace(/\n/g, " ").replace(/,/g, " ") || "",
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "enquiries.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}

      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              {/* <div className="pageNameDiv">
                <p className="breadcrumb-item">
                  {GuestManagementPageText.Guest_Management}
                </p>
                <img src={GreyArrow} alt="Rapid Car Leasing" />
              </div> */}
              <div className="calendertabs">
                <div className="calendertabs_container">
                  {" "}
                  <div
                    className={`calendertabsBtn ${
                      ownCarTab ? "activeCalendarTab" : ""
                    }`}
                    style={{ width: "140px" }}
                    onClick={() => toggleTabs("own")}
                  >
                    <p>Contact Us</p>
                  </div>
                  <div
                    className={`calendertabsBtn ${
                      !ownCarTab ? "activeCalendarTab" : ""
                    }`}
                    style={{ width: "140px" }}
                    onClick={() => toggleTabs("new")}
                  >
                    <p>Resources Page</p>
                  </div>
                </div>
              </div>
              <div className={` alignCol bottomAlgin col-xl-3 mb-0`}>
                <div className="pageActionBtns">
                  <button
                    className="CSVBTN"
                    style={{ height: "38px" }}
                    onClick={downloadCSV}
                  >
                    Download Excel
                  </button>
                </div>
              </div>
              <Button
                onClick={goBack}
                startIcon={
                  <ArrowLeft size={17} style={{ marginBottom: "2px" }} />
                }
                className="Back_bttn_page"
              >
                Back
              </Button>
            </div>

            <div className="page_body">
              <div className="viewStaff">
                <div className="viewStaff_head">
                  <div className="row m-0">
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.Start_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={startDate}
                          onChange={handleDateChange}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-4 bottomAlgin">
                      <label className="labelView">
                        {GuestManagementPageText.End_Date}
                      </label>
                      <div className="person__calenderFrame_image image_icon_position1 ">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          minDate={startDate}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-sm-4 bottomAlgin">
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={FilterIcon} alt="Rapid Car Leasing" />
                        </label>
                        <select id="selectFilter" onChange={handleSelect}>
                          {options_search.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-5 col-sm-8 bottomAlgin">
                      <div className="inputDiv2">
                        <img src={Search} alt="Rapid Car Leasing" />
                        <input
                          type="text"
                          id="search_data"
                          onInput={(e) => {
                            if (selectedValue === options_search[0].value) {
                              handleAphabetsChange(e);
                            } else if (
                              selectedValue === options_search[1].value
                            ) {
                              handleEmailChange(e);
                            } else if (
                              selectedValue === options_search[2].value
                            ) {
                              handleNumbersChange(e);
                            }
                          }}
                          placeholder={GuestManagementPageText.Search_Guest}
                        />
                        <button
                          type="button"
                          className="btnSearch"
                          onClick={() => search_data()}
                        >
                          {GuestManagementPageText.Search_text}
                        </button>
                      </div>
                    </div>

                    <div
                      className="col-xl-3 col-md-4"
                      style={{ marginLeft: "auto", marginRight: "0" }}
                    >
                      <div className="inputDiv2">
                        <label className="labelPointer" htmlFor="selectFilter">
                          <img src={FilterIcon} alt="Rapid Car Leasing" />
                        </label>
                        <input
                          type="text"
                          placeholder={GuestManagementPageText.Guest_Filter}
                          value={searchfilter}
                          onInput={handleIaphabetnumberChange}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ padding: "0 10px" }}>
                  <div className="cust_hist_card" style={{ padding: "0 10px" }}>
                    <div className="reservationHistoryTable">
                      <div
                        className="historyTableContainer stickyTableheigh274"
                        style={{ overflowX: "auto" }}
                      >
                        <table className="table margin_class_table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">Sr.No.</th>
                              <th scope="col"> Entry Date</th>
                              <th scope="col">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={GuestIcon}
                                    alt="Rapid Car Leasing"
                                    style={{ height: "20px", width: "20px" }}
                                  />
                                  <span className="fontWeight600">
                                    {GuestManagementPageText.Guest_Name}
                                  </span>
                                </div>
                              </th>
                              <th scope="col">
                                {" "}
                                {GuestManagementPageText.Contact_Details}
                              </th>
                              <th scope="col">
                                {" "}
                                {GuestManagementPageText.Email_ID}
                              </th>
                              <th scope="col">
                                {" "}
                                {GuestManagementPageText.Purpose}
                              </th>
                              <th scope="col">
                                {GuestManagementPageText.Booking_text}
                              </th>
                            </tr>
                          </thead>
                          <tbody className="custum_border">
                            {currentItems && currentItems.length > 0 ? (
                              currentItems.map((option, index) => (
                                <tr
                                  className="historyTableRow h-auto"
                                  key={index}
                                >
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyName"
                                      style={{
                                        marginLeft: "20px",
                                      }}
                                    >
                                      {indexOfFirstItem + index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                      {mondayDayYearFormat(option.entry_date)}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                      {option.name}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="historyTableRowText height50 historyName">
                                      {option.phone}
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      className="historyTableRowText height50 historyPerson"
                                      style={{ flexWrap: "wrap" }}
                                    >
                                      {option.email}
                                    </div>
                                  </td>
                                  <td>
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={(e) =>
                                        handleViewClick(
                                          e,
                                          imgname + option.dropdown
                                        )
                                      }
                                    >
                                      <Eye
                                        size={18}
                                        className="icon_imgGG"
                                        style={{
                                          cursor: "pointer",
                                          color: "var(--primary-color)",
                                          marginTop: "5px",
                                        }}
                                        strokeWidth={1.5}
                                      />
                                    </span>
                                  </td>
                                  <td>
                                    <Eye
                                      onClick={() =>
                                        handleShowModal(option.message)
                                      }
                                      size={18}
                                      style={{
                                        cursor: "pointer",
                                        color: "var(--primary-color)",
                                        marginTop: "5px",
                                      }}
                                      strokeWidth={1.5}
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={6} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {/* Pagination Footer */}
                        <div className="cust_hist_card_footer">
                          <div className="cust_hist_pagination_info">
                            {filteredData.length > 0 ? (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  {indexOfFirstItem + 1}
                                </span>{" "}
                                to{" "}
                                <span className="cust_hist_pagination_bold">
                                  {Math.min(
                                    indexOfLastItem,
                                    filteredData.length
                                  )}
                                </span>{" "}
                                of{" "}
                                <span className="cust_hist_pagination_bold">
                                  {filteredData.length}
                                </span>{" "}
                                guests
                              </>
                            ) : (
                              <>
                                Showing{" "}
                                <span className="cust_hist_pagination_bold">
                                  0
                                </span>{" "}
                                guests
                              </>
                            )}
                          </div>
                          <div className="cust_hist_pagination">
                            <nav aria-label="Pagination">
                              <ul className="cust_hist_pagination_list">
                                {renderPaginationButtons()}
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="viewGuest_table ">
                  <div className="viewGuest_table_container stickyTableheigh274 ">
                    <div className="row m-0">
                      <div className="col-md-12">
                        <table className="table">
                          <thead className="stickyHeaderClss">
                            <tr>
                              <th scope="col">
                                <div className="theadStyle imgThead  ">
                                  <span className="fontWeight600">S.No</span>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="theadStyle imgThead  ">
                                  <span className="fontWeight600">Entry Date</span>
                                </div>
                              </th>

                              <th scope="col">
                                <div className="theadStyle imgThead  ">
                                  <img
                                    src={GuestIcon}
                                    alt="Rapid Car Leasing"
                                  />
                                  <span className="fontWeight600">
                                    {GuestManagementPageText.Guest_Name}
                                  </span>
                                </div>
                              </th>
                              <th scope="col">
                                <div className="theadStyle fontWeight600">
                                  {GuestManagementPageText.Contact_Details}
                                </div>
                              </th>
                              <th scope="col">
                                <div className="theadStyle fontWeight600">
                                  {GuestManagementPageText.Email_ID}
                                </div>
                              </th>
                              <th scope="col">
                                <div className="theadStyle fontWeight600">
                                  {GuestManagementPageText.Purpose}
                                </div>
                              </th>
                              <th scope="col">
                                <div className="theadStyle fontWeight600">
                                  {GuestManagementPageText.Booking_text}
                                </div>
                              </th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody className="tboday">
                            {currentItems.map((option, index) => (
                              <React.Fragment key={index}>
                                <tr className="tableRow tbodyStyle">
                                  <td className="th1 tabledata">
                                    <div className="guest_incenter borderLeftRadius">
                                      {indexOfFirstItem + index + 1}
                                    </div>
                                  </td>
                                  <td className="th1 tabledata">
                                    <div className="guest_incenter borderLeftRadius">
                                      {mondayDayYearFormat(option.entry_date)}
                                    </div>
                                  </td>
                                  <td className="th1 tabledata">
                                    <div className="guest_incenter borderLeftRadius">
                                      {option.name}
                                    </div>
                                  </td>
                                  <td className="tabledata">
                                    <div className="guest_incenter shadowOnlyBottom">
                                      {option.phone}
                                    </div>
                                  </td>
                                  <td className="tabledata">
                                    <div className="guest_incenter shadowOnlyBottom">
                                      {option.email}
                                    </div>
                                  </td>
                                  <td className="tabledata">
                                    <span
                                      style={{ cursor: "pointer" }}
                                      onClick={(e) =>
                                        handleViewClick(
                                          e,
                                          imgname + option.dropdown
                                        )
                                      }
                                    >
                                      <Eye
                                        size={18}
                                        className="icon_imgGG"
                                        style={{
                                          cursor: "pointer",
                                          color: "var(--primary-color)",
                                          marginTop: "5px",
                                        }}
                                        strokeWidth={1.5}
                                      />
                                    </span>
                                  </td>
                                  <td className="tabledata">
                                    <Eye
                                      onClick={() =>
                                        handleShowModal(option.message)
                                      }
                                      size={18}
                                      style={{
                                        cursor: "pointer",
                                        color: "var(--primary-color)",
                                        marginTop: "5px",
                                      }}
                                      strokeWidth={1.5}
                                    />
                                  </td>
                                </tr>
                                <tr
                                  key={`spacer-${index}`}
                                  style={{ height: "1rem" }}
                                ></tr>
                              </React.Fragment>
                            ))}
                            {currentItems.length === 0 && (
                              <tr>
                                <td colSpan={7} className="text_align_center">
                                  No Results Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ------testimonial message Modal------------ */}
      <Modal
        className="testMsgModal"
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Body>
          <div className="closeBtn" onClick={handleCloseModal}>
            <FaTimes className="closeIcn" />
          </div>
          <div className="testiModalMsg">
            <h4>Messages</h4>
            <p>{modalMessage}</p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default GuestMngmt;
